var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Normili_Logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "312.87px",
    height: "310.42px",
    viewBox: "0 0 312.87 310.42",
    style: {
      enableBackground: "new 0 0 312.87 310.42"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\t.color {\n\t\t\tfill: red;\n\t\t}\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("path", {
    className: "color",
    d: "M156.44,48.56l4.93-4.5C185.08,22.4,209.6,0,245.99,0c39.38,0,66.88,26.2,66.88,63.71 c0,35.73-31.08,63.71-70.75,63.71c-13.87,0-26.39-4.16-37.9-10.5c-0.05-0.03-0.16-0.09-0.16-0.09l17.26-15.92 c0,0,0.07,0.03,0.1,0.04c6.62,2.82,13.47,4.46,20.69,4.46c27.34,0,48.75-18.32,48.75-41.71c0-25.34-17.62-41.71-44.88-41.71 c-27.86,0-47.29,17.75-69.8,38.31l-3.72,3.4l-16.04,15.15l-4.93,4.5c-23.71,21.66-48.23,44.06-84.62,44.06 c-18.73,0-35.71-6.29-47.83-17.72C6.77,98.11,0,81.78,0,63.71C0,27.98,31.08,0,70.75,0c16.85,0,31.69,6.14,45.17,14.86 c0.03,0.02,0.09,0.06,0.09,0.06L99.26,30.36c0,0-0.06-0.03-0.08-0.05C90.17,25.19,80.82,22,70.75,22C43.41,22,22,40.32,22,63.71 c0,24.95,18.04,41.71,44.88,41.71c27.86,0,47.29-17.75,69.79-38.31l3.73-3.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "color",
    points: "163.16,310.42 283.18,144.2 256.16,144.19 149.55,291.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "color",
    points: "213.09,166.2 58.37,166.2 42.37,144.2 229.01,144.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "color",
    points: "179.13,213.2 92.53,213.2 76.53,191.2 195.03,191.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "color",
    points: "144.43,261.2 127.42,261.2 111.41,239.2 160.34,239.2  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRed);
export default __webpack_public_path__ + "static/media/logo_red.6c51c8ddd51582d742d02375d0d24995.svg";
export { ForwardRef as ReactComponent };